import $ from "jquery";
import moment from 'moment/min/moment-with-locales'
import 'daterangepicker'
import 'tablesorter';
import 'tablesorter/dist/js/jquery.tablesorter'
import 'tablesorter/dist/js/jquery.tablesorter.combined'
import 'tablesorter/dist/js/jquery.tablesorter.widgets'
import 'tablesorter/dist/js/extras/jquery.tablesorter.pager.min'
import 'tablesorter/dist/js/widgets/widget-output.min.js'

let isMobile = false;

const NOT_VISIBLE = 'd-none';

const tableInitialize = (elementTableId, expandElementId = null) => {

    let table = $(elementTableId)
        .tablesorter({
            theme: "bootstrap",
            dateFormat: "MM/DD/YYYY",
            headers: {
                0: {dateFormat: "MM/DD/YYYY"},
                2: {sorter: "digit"}
            },
            widthFixed: true,
            fixColumnWidth: true,
            showProcessing: true,
            widgets: ["filter", "columns", "output"],

            widgetOptions: {
                columns: ['primary', 'secondary', 'tertiary'],

                filter_cssFilter: [
                    isMobile === false ? 'form-control datepicker' : 'form-control',
                    'form-control',
                    NOT_VISIBLE,
                    'form-control',
                    NOT_VISIBLE,
                ],
                filter_childRows: false,

                filter_childByColumn: false,

                filter_reset: '.reset',

                // filter_filteredRow: '.filtered',

                //--------- for Export -------------------------
                // popup, download
                output_delivery: 'download',

                // if saving a file, set the file name here
                output_saveFileName: (location.pathname === '/loan-history') ? 'export_LoanHistory.csv' : 'export_BalanceHistory.csv', // 'exportTable.csv',

                // set to "json", "array" or any separator
                output_separator: ';',

                // all, visible or filtered
                //output_saveRows: 'all',
                output_saveRows: ':not(.tablesorter-childRow)',

                // Add the zero-based column index to this array to ignore specific columns
                output_ignoreColumns: [4],

                // if true, include multiple header rows (JSON only)
                output_headerRows: false,

                // if true, include any HTML within the table cell
                output_includeHTML: false,

                // remove extra whitespace before & after the cell content
                output_trimSpaces: true,

                // the need to modify this for Excel no longer exists
                //output_encoding : 'data:application/octet-stream;charset=utf8,',
                //output_encoding : 'data:text/csv;charset=utf8,',

                output_formatContent: function (config, widgetOptions, data) {
                    // data.isHeader (boolean) = true if processing a header cell
                    // data.$cell = jQuery object of the cell currently being processed
                    // data.content = processed cell content
                    //    (spaces trimmed, quotes added/replaced, etc)
                    // **********
                    // use data.$cell.html() to get the original cell content

                    var BOM = "\uFEFF"; // set Excel enconding UTF-8
                    return BOM + data.content.replace(/&amp;/g, '&').replace(/ +/g, ' '); // data.content is HTML text converted so '&' has been converted to &amp; which is the HTML reprensetation of the '&' character. Convert it back to show '&' in the CSV.
                }


                //--------- end: for Export -------------------------
            }
        })

        .on('apply.daterangepicker', function (event, picker) {
            const endDate = moment(picker.endDate).add(1, 'days')
            picker.setEndDate(endDate)
            table.trigger('search');
        })

        .on('cancel.daterangepicker', function (event, picker) {
            $('.datepicker').val('')
        })

        .bind('initialized filterEnd', function () {
            $('#all').prop('checked', false);
            $('#filtered').prop('checked', true);

            if (location.pathname === '/loan-history') {
                countTotal(elementTableId, 2, 'USD');
            }
            if (location.pathname === '/balance-history') {
                countTotal(elementTableId, 8, 'BTC');
            }

            $("#filtered").removeAttr("disabled");

        })

        .tablesorterPager({
            container: $(".ts-pager"),
            cssGoto: ".pagenum",
            removeRows: false,
            output: '{startRow} - {endRow} / {filteredRows} ({totalRows})'
        });

    if (expandElementId) {
        document.getElementById(expandElementId).style.display = '';
    }

    $('.datepicker').daterangepicker({
        locale: {
            format: 'MM/DD/YYYY',
            firstDay: 1,
        },
        startDate: '01/23/2020',
        minYear: 2020,
    });

    table.delegate('.toggle', 'click', function () {
        $(this)
            .closest('tr')
            .nextUntil('tr.tablesorter-hasChildRow')
            .toggleClass(NOT_VISIBLE);

        return false;
    });

    table.delegate('.toggle-close', 'click', function () {
        $(this)
            .closest('tr')
            .nextUntil('tr.tablesorter-hasChildRow')
            .toggleClass(NOT_VISIBLE);

        return false;
    });

    $('button.toggle-byColumn').click(function () {
        var wo = table[0].config.widgetOptions,
            o = !wo.filter_childByColumn;
        wo.filter_childByColumn = o;
        $('.state2').html(o.toString());
        // update filter; include false parameter to force a new search
        table.trigger('search', false);
        return false;
    });

    // only one radio can be active in export
    $('#group input:radio').click(function () {
        if ($(this).is(':checked')) {
            $('#group input:radio').not(this).prop('checked', false);
        }
    });

    $('button.download').click(function () {

        let date = new Date().toLocaleDateString(); // 19.12.2019
        let fileName = (location.pathname === '/loan-history') ? 'Loan' : 'Balance';
            fileName = ($('#group input#all:radio').is(':checked')) ? fileName+'_All_'+date+'.csv' : fileName+'_Filtered_'+date+'.csv';
        table[0].config.widgetOptions.output_saveFileName = fileName;

        if ($('#all').is(':checked')) {
            //table[0].config.widgetOptions.output_saveRows = 'all'; // puts also Details
            table[0].config.widgetOptions.output_saveRows = ':not(.tablesorter-childRow)'; // without Details
        } else {
            //table[0].config.widgetOptions.output_saveRows = 'filtered'; // without Details
            table[0].config.widgetOptions.output_saveRows = ':not(.filtered):not(.tablesorter-childRow)'; // without Details
            table[0].config.widgetOptions.output_saveRows = ':not(.filtered):not(.tablesorter-childRow)'; // without Details
        }

        table.trigger('outputTable');

        return false;
    })
}

const balanceTableInit = (expandElementId) => {
    tableInitialize('#history-balance-table', expandElementId);
}

const balanceTableMobInit = () => {
    tableInitialize('#history-balance-table-sm');
}

const depositTableInit = (expandElementId) => {
    tableInitialize('#history-deposit-table', expandElementId);
}

const depositTableMobInit = () => {
    tableInitialize('#history-deposit-table-sm');
}

const loanTableMobInit = () => {
    tableInitialize('#history-loan-table-sm');
}

const loanTableInit = (expandElementId) => {
    tableInitialize('#history-loan-table', expandElementId);
}

const uniqueVal = (value, index, self) => {
    //leave only unique values in array
    return self.indexOf(value) === index;
}

const countTotal = (elementTableId, digitsRound, currency) => {
    let total = 0;

    let opValues = [];
    let stValues = [];

    $(elementTableId).find('tbody tr.tablesorter-hasChildRow:not(.filtered)').each(function () {
        opValues.push($(this).find('td:eq(1)').text());
        stValues.push($(this).find('td:eq(3) span').text());
        let amount = $(this).find('td:eq(2)').text();
        total += parseFloat(amount.replace(',', ''));
    });

    let opCountUnique = opValues.filter(uniqueVal).length;
    let stCountUnique = stValues.filter(uniqueVal).length;

    total = total.toFixed(digitsRound) + ' ' + currency;

    if ((opCountUnique === 1) && (stCountUnique === 1))
        $('tr[role="search"] td[data-column="2"]').text(total).css("table-bold-content ");
    else
        $('tr[role="search"] td[data-column="2"]').text('');
}

const detectMobile = () => {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
       isMobile = true;
    }
}

const loanInit = () => {
    if (isMobile) {
        loanTableMobInit();
    } else {
        loanTableInit('history-loan-table-expand');
    }
}

const balanceInit = () => {
    if (isMobile) {
        balanceTableMobInit();
    } else {
        balanceTableInit('history-balance-table-expand');
    }
}

const depositInit = () => {
    if (isMobile) {
        depositTableMobInit();
    } else {
        depositTableInit('history-deposit-table-expand');
    }
}

$(document).ready(() => {
    detectMobile()
    if (location.pathname === '/loan-history') {
        loanInit()
    }
    if (location.pathname === '/balance-history') {
        balanceInit()
    }
    if (location.pathname === '/deposit-history') {
        depositInit()
    }
})

